import Axios from 'axios';

const getAllContent = () => {
    return new Promise((promiseResolve, promiseReject) => {
        Axios.all([
            Axios.get('/lks/app/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
            Axios.get('/lks/app/event-info/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
            Axios.get('/lks/app/event-info/overview/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
            Axios.get('/lks/app/event-info/itinerary/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
            Axios.get('/lks/app/event-info/venue-info/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
            Axios.get('/lks/app/event-info/attendees/index.php', { headers: {'X-US-ACIC': 'acwe' }}),
        ])
        .then(Axios.spread((homepageContent, eventInfoContent, eventInfoOverviewContent, eventInfoItineraryContent, eventInfoVenueInfoContent, eventInfoAttendeesContent, myStampsContent) => {
            promiseResolve([homepageContent, eventInfoContent, eventInfoOverviewContent, eventInfoItineraryContent, eventInfoVenueInfoContent, eventInfoAttendeesContent, myStampsContent]);
        }))
        .catch((error) => {
            promiseReject(error);
        });
    });
};

export default {
    getAllContent
};